export const LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_demo-scheduler-4/artifacts/ytjqb8f0_campuspath-logov2-removebg-preview%20%281%29.png";

export const TG_LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_demo-scheduler-4/artifacts/36glhcgd_testguard-logo-removebg-preview.png";

// Social share (Open Graph) card images, one per product.
export const OG_IMAGE_CAMPUSPATH =
  "https://static.prod-images.emergentagent.com/jobs/b0d8cddc-8dcd-49de-a575-3bcce91cfb02/images/8791dad6388daaf8ea89659b1481c127690f61b51c745de72c99b6735ec2bb32.png";
export const OG_IMAGE_TESTGUARD =
  "https://static.prod-images.emergentagent.com/jobs/b0d8cddc-8dcd-49de-a575-3bcce91cfb02/images/2de6457f1e0ca7c6a23947b6c825cb3027c72ddce134dd5694b492e427fe7ed2.png";

export const CONTACT_EMAIL = "accounts@campuspath.org";

// Cross-product canonical domains, CampusPath and TestGuard run as two
// independent products on their own domains.
export const CAMPUSPATH_URL = "https://campuspath.org";
export const TESTGUARD_URL = "https://testguard.org";

// In production each product lives on its own domain; in the preview/local
// environment (no custom domains linked) fall back to the internal route so
// the page stays reachable.
function isPreviewOrLocal() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname.toLowerCase();
  return (
    h.includes("emergentagent") ||
    h.includes("localhost") ||
    h.startsWith("127.") ||
    h.endsWith(".local")
  );
}

// This deployment is a standalone TestGuard site (REACT_APP_PRODUCT=testguard)
// sharing the CampusPath backend. When set, the root "/" always renders the
// TestGuard product and cross-links point to the real CampusPath domain.
export const STANDALONE_TESTGUARD =
  (process.env.REACT_APP_PRODUCT || "").toLowerCase() === "testguard";

// Resolve which product a lead/booking page should use. An explicit
// ?product= query param always wins; otherwise the standalone TestGuard
// deployment defaults to TestGuard, and everything else to CampusPath.
export function resolveProduct(queryProduct) {
  if (queryProduct === "testguard") return "testguard";
  if (queryProduct === "campuspath") return "campuspath";
  return STANDALONE_TESTGUARD ? "testguard" : "campuspath";
}

export function testguardHref() {
  if (STANDALONE_TESTGUARD) return "/";
  return isPreviewOrLocal() ? "/testguard" : TESTGUARD_URL;
}

export function campuspathHref() {
  if (STANDALONE_TESTGUARD) return CAMPUSPATH_URL;
  return isPreviewOrLocal() ? "/" : CAMPUSPATH_URL;
}

// Real portrait photos (face-cropped) for social proof avatars
export const PEOPLE = [
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=faces&fit=crop&w=200&h=200&q=80",
  "https://images.unsplash.com/photo-1507152832244-10d45c7eda57?crop=faces&fit=crop&w=200&h=200&q=80",
  "https://images.pexels.com/photos/9092311/pexels-photo-9092311.jpeg?auto=compress&cs=tinysrgb&w=200&h=200&fit=crop",
  "https://images.unsplash.com/photo-1611432579402-7037e3e2c1e4?crop=faces&fit=crop&w=200&h=200&q=80",
];
export const RYAN_PHOTO =
  "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&w=160&h=160&fit=crop";

// Committed locally under /public/videos so the assets travel with the repo.
export const VIDEOS = {
  hallway: {
    src: "/videos/hallway.mp4",
    poster: "/videos/hallway-poster.jpg",
  },
  dataCenter: {
    src: "/videos/datacenter.mp4",
    poster: "/videos/datacenter-poster.jpg",
  },
  examComputer: {
    src: "/videos/examcomputer.mp4",
    poster: "/videos/examcomputer-poster.jpg",
  },
};

export const IMAGES = {
  school:
    "https://images.unsplash.com/photo-1705810591530-02053b1a9954?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBzY2hvb2wlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODQxNjg0MzZ8MA&ixlib=rb-4.1.0&q=85",
  teacher:
    "https://images.unsplash.com/photo-1720048171315-b76d4d7269f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHx0ZWFjaGVyJTIwdXNpbmclMjB0YWJsZXR8ZW58MHx8fHwxNzg0MTY4NDM2fDA&ixlib=rb-4.1.0&q=85",
  students:
    "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxzdHVkZW50cyUyMGluJTIwc2Nob29sfGVufDB8fHx8MTc4NDE2ODQzNnww&ixlib=rb-4.1.0&q=85",
  buses:
    "https://images.unsplash.com/photo-1628471047004-f4fe9a1d9e18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHx5ZWxsb3clMjBzY2hvb2wlMjBidXNlcyUyMGxpbmV1cHxlbnwwfHx8fDE3ODQxNjg1NjB8MA&ixlib=rb-4.1.0&q=85",
  lock:
    "https://images.unsplash.com/photo-1614064548237-096f735f344f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwc2VjdXJpdHklMjBsb2NrfGVufDB8fHx8MTc4NDE2ODQzNnww&ixlib=rb-4.1.0&q=85",
  examLaptop:
    "https://images.unsplash.com/photo-1758270705290-62b6294dd044?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxzdHVkZW50cyUyMGV4YW0lMjBsYXB0b3AlMjBjbGFzc3Jvb218ZW58MHx8fHwxNzg0MTY4NTYwfDA&ixlib=rb-4.1.0&q=85",
  gradebook:
    "https://images.pexels.com/photos/6684372/pexels-photo-6684372.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const CHAPTERS = [
  {
    n: "01",
    title: "Arrival & Dismissal",
    line: "Every student accounted for, from curb to classroom and back again.",
    tag: "Verified pickups",
    img: IMAGES.students,
  },
  {
    n: "02",
    title: "Attendance",
    line: "Real-time rolls, with parents notified the moment a seat is empty.",
    tag: "Auto notifications",
    img: IMAGES.teacher,
  },
  {
    n: "03",
    title: "Gradebook",
    line: "Grades families can actually follow, with quiet alerts when it counts.",
    tag: "Low-grade alerts",
    img: IMAGES.gradebook,
  },
  {
    n: "04",
    title: "Family Communication",
    line: "One broadcast. Every language. Delivered by email and SMS.",
    tag: "Auto-translation",
    img: IMAGES.students,
  },
  {
    n: "05",
    title: "Transportation",
    line: "Which bus, which route, which child, and a heads-up before they arrive.",
    tag: "Bus-ready alerts",
    img: IMAGES.buses,
  },
];

export const ROLES = [
  { role: "Administrators", line: "Full oversight of the school and control over how the platform is configured." },
  { role: "Teachers", line: "Attendance, grades, dismissal and the information for their own classes." },
  { role: "Staff", line: "Run the pickup line and keep arrival and dismissal moving safely." },
  { role: "Parents", line: "Stay informed and act directly, change today's pickup, track grades and attendance." },
  { role: "Students", line: "Older students get read-only access, taking ownership of their day." },
];

export const STATS = [
  { value: "-55%", label: "Dismissal wait time", school: "Lincoln Elementary" },
  { value: "100%", label: "Pickup verification", school: "Oakridge Academy" },
  { value: "12", label: "Campuses unified", school: "Westside District" },
  { value: "45–90", label: "Day free trial, fully featured", school: "No credit card required" },
];

export const SECURITY = [
  { title: "Student-Privacy Focused", line: "Built to protect student data, support trusted family access, and keep operations secure." },
  { title: "End-to-End Encryption", line: "All student and parent data encrypted at rest and in transit with 256-bit AES." },
  { title: "Role-Based Access", line: "Everyone sees exactly what they should, and nothing they shouldn't." },
  { title: "Daily Cloud Backups", line: "Enterprise-grade infrastructure with automated backups and 99.99% uptime." },
];

export const SAFETY_FEATURES = [
  { icon: "UserCheck", title: "Verified Pickup", line: "Only authorized guardians can collect a student, every pickup is matched and logged." },
  { icon: "Fingerprint", title: "Guardian Identity", line: "Digital pickup passes and photo verification keep the wrong hands out, every time." },
  { icon: "Siren", title: "Emergency Ready", line: "One tap launches reunification and alerts staff and families within seconds." },
  { icon: "ClipboardCheck", title: "Live Accountability", line: "Know exactly who is on campus, in transit, or safely home, in real time." },
  { icon: "ShieldAlert", title: "Visitor Screening", line: "Every visitor is checked in and badged, so no one moves through campus unseen." },
  { icon: "Bus", title: "Safe Transport", line: "Bus-to-parent handoffs are tracked end to end, with arrival alerts for families." },
];
